// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-google-autocomplete';

// INNER IMPORTS
import { BAND } from '../../../consts';

// css imports
import './BandFinderForm.css';
import SVGInline from 'react-svg-inline';
import locationBlueSVG from '../../inlineSVGs/locationBlueSVG';

const BandFinderForm = ({ userShouldEnter, name, formType, updateValue = () => {}, updateLocation = () => {} }) => {
    return (
        <div className="band-finder-from-wrapper rtl">
            <div className="leftPart">
                <input type="text" name="name" placeholder={formType === BAND ? 'שם הלהקה?' : 'שם?'} onChange={updateValue} value={name}
                       className={`${formType} ${(userShouldEnter && userShouldEnter.indexOf('name') > -1 ? 'required' : '')}`}/>
            </div>
            <div className="rightPart rtl">
                <SVGInline className="icon-location" svg={locationBlueSVG} width="25px" />

                <Autocomplete
                    placeholder={'מאיפה?'}
                    id="autocomplete"
                    onPlaceSelected={(place) => {updateLocation(place)}}
                    types={['geocode', 'establishment']}
                    className={`${formType} ${(userShouldEnter && userShouldEnter.indexOf('location') > - 1 ? 'required' : '')}`}/>
            </div>
        </div>
    )
};

BandFinderForm.propTypes = {
    name: PropTypes.string,
    formType: PropTypes.string,
    userShouldEnter: PropTypes.array,
    updateValue: PropTypes.func,
    updateLocation: PropTypes.func
};

export default BandFinderForm;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/BandFinderForm.js